import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { Card, Form, Input, InputNumber, Switch, Button, Select, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getAllExploreCategories } from '../../graphql/queries';
import { createExploreAudio } from '../../graphql/mutation';
import './Explore.css';

const { TextArea } = Input;

const CreateExploreAudio = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const { data: categoriesData } = useQuery(getAllExploreCategories);
  const categories = categoriesData?.getAllExploreCategories || [];

  const [createAudio, { loading }] = useMutation(createExploreAudio, {
    onCompleted: () => {
      message.success('Audio created successfully');
      navigate('/explore');
    },
    onError: (error) => message.error(error.message)
  });

  const onFinish = (values) => {
    createAudio({
      variables: {
        input: {
          name: values.name,
          categoryId: values.categoryId,
          audioUrl: values.audioUrl,
          imageUrl: values.imageUrl || null,
          prompt: values.prompt || null,
          lyrics: values.lyrics || null,
          order: values.order || 0,
          isActive: values.isActive ?? true
        }
      }
    });
  };

  return (
    <div className="explore-container">
      <div className="page-header">
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/explore')}
          style={{ marginBottom: 16 }}
        >
          Back to Explore
        </Button>
        <h1 className="page-title">Create Explore Audio</h1>
        <p className="page-subtitle">Add a new featured audio</p>
      </div>

      <Card className="explore-card" style={{ maxWidth: 700 }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ order: 0, isActive: true }}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please enter audio name' }]}
          >
            <Input placeholder="Audio name" />
          </Form.Item>

          <Form.Item
            name="categoryId"
            label="Category"
            rules={[{ required: true, message: 'Please select a category' }]}
          >
            <Select placeholder="Select category">
              {categories.map(cat => (
                <Select.Option key={cat.id} value={cat.id}>
                  {cat.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="audioUrl"
            label="Audio URL"
            rules={[
              { required: true, message: 'Please enter audio URL' },
              { type: 'url', message: 'Please enter a valid URL' }
            ]}
          >
            <Input placeholder="https://..." />
          </Form.Item>

          <Form.Item
            name="imageUrl"
            label="Image URL"
            rules={[{ type: 'url', message: 'Please enter a valid URL' }]}
          >
            <Input placeholder="https://..." />
          </Form.Item>

          <Form.Item
            name="prompt"
            label="Prompt"
          >
            <TextArea rows={3} placeholder="Audio prompt" />
          </Form.Item>

          <Form.Item
            name="lyrics"
            label="Lyrics"
          >
            <TextArea rows={4} placeholder="Audio lyrics" />
          </Form.Item>

          <Form.Item
            name="order"
            label="Order"
          >
            <InputNumber min={0} style={{ width: '100%' }} placeholder="Display order" />
          </Form.Item>

          <Form.Item
            name="isActive"
            label="Active"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Create Audio
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateExploreAudio;
